<template>
  <f7-page>
    <f7-navbar :title="title + ' ' + extraTitle" back-link="Terug"></f7-navbar>
    <div class="px-2 pt-2 pb-1" v-if="metaData">
      Er zijn in totaal {{ active_subscriptions }} actieve abonnementen
    </div>
    <div class="px-2 pb-2">
      <f7-segmented strong tag="p" class="my-0">
        <f7-button :active="subscriptionStatusFilter === 2" @click="subscriptionStatusFilter = 2">
          Alles
        </f7-button>
        <f7-button :active="subscriptionStatusFilter === 1" @click="subscriptionStatusFilter = 1">
          Actief
        </f7-button>
        <f7-button :active="subscriptionStatusFilter === 0" @click="subscriptionStatusFilter = 0">
          Inactief
        </f7-button>
      </f7-segmented>
    </div>
    <div class="px-2 pb-2">
      <f7-segmented strong tag="p" class="my-0">
        <f7-button :active="subscriptionSort === 'desc'" @click="subscriptionSort = 'desc'">
          Nieuw > Oud
        </f7-button>
        <f7-button :active="subscriptionSort === 'asc'" @click="subscriptionSort = 'asc'">
          Oud > Nieuw
        </f7-button>
      </f7-segmented>
    </div>
    <users-search
      @updated="data = $event"
      @updatedMetaData="metaData = $event"
      :data="data"
      :subscriptionStatusFilter="subscriptionStatusFilter"
      :subscriptionSort="subscriptionSort"
    >
      <template v-for="user in data">
        <f7-list-item v-if="subscriptionStatusFilter === 2 || (subscriptionStatusFilter === 1 && user.has_active_subscription) || (subscriptionStatusFilter === 0 && !user.has_active_subscription)"
                      :link="'/users/' + user.id"
                      :title="user.first_name + ' ' + user.last_name"
                      :badge="user.account_type">
          <template #footer>
            {{ user.email }}<br/>
            {{ user.credits }} credits<br/>
            Account sinds: {{ user.created_at }}
          </template>
        </f7-list-item>
      </template>
    </users-search>
  </f7-page>
</template>

<script>

import UsersSearch from "@/components/account/users/UsersSearch.vue";

export default {
  components: {UsersSearch},

  props: [],

  mixins: [

  ],

  data: function () {
    return {
      show_loader: true,
      title: 'Gebruikers',
      query: '',
      data: [],
      metaData: null,
      subscriptionStatusFilter: 2,
      subscriptionSort: 'desc',
    };
  },

  computed: {
    extraTitle() {
      return this.query.length === 0 ? '(laatste 100)' : '(gefiltert)';
    },
    active_subscriptions() {
      if(this.metaData) {
        return this.metaData.active_subscriptions;
      }
    }
  },

  created() {
    //
  },

  mounted() {
    //
  },

  methods: {
    //
  },

  watch: {
    //
  }
};
</script>
